import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { REMOVE_NOTIFICATION } from "../notification.queries";
import {
  RemoveNotificationMutation,
  RemoveNotificationMutationVariables,
} from "../../../__generated__/RemoveNotificationMutation";

export const useRemoveNotification = () => {
  return useMutation<RemoveNotificationMutation, RemoveNotificationMutationVariables>(
    REMOVE_NOTIFICATION,
    {
      refetchQueries: ["MyNotificationsQuery"],
      update(cache) {
        evictFields(cache, ["myNotifications", "notification"]);
      },
    }
  );
};
